import type { Steps, Tasks } from '../../workflow/schemaTypes';

export const itemSelectionStepId: Steps = 'itemSelection';
export const eligibleItemTaskId: Tasks = 'itemSelection';

export const headerContainer = 'headerContainer';
export const headerId = 'header';
export const subheaderId = 'subheader';
export const separator = 'separator';
export const eligibleHeader = 'eligibleHeader';
export const ineligibleHeader = 'ineligibleHeader';
export const ineligibleItemsContainer = 'ineligibleItemsContainer';
